<template>
    <fieldset id="contentformuser">
        <div class="row">
            <div class="col-8 offset-2 div-user">
                <legend>{{ translate.titleFormUser }}</legend>
                <div class="row my-2">
                    <div class="col-12 col-md-6">
                        <div class="form-group">
                            <input type="text" class="form-control" id="firstName" ref="firstName"
                                :placeholder="translate.formUser.firstName" v-model="form.firstName" />
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group">
                            <input ref="lastName" type="text" class="form-control" name="lastName" id="lastName"
                                :placeholder="translate.formUser.lastName" v-model="form.lastName">
                        </div>
                    </div>
                </div>
                <div class="row my-2">
                    <div class="col-12 col-md-6">
                        <div class="form-group">
                            <input ref="email" type="email" class="form-control" v-model="form.email" name="email"
                                id="email" :placeholder="translate.formUser.email" />

                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group">
                            <input ref="emailAgain" type="email" class="form-control" v-model="form.emailAgain"
                                name="emailAgain" id="emailAgain" :placeholder="translate.formUser.emailAgain" />

                        </div>
                    </div>
                </div>
                <div class="row my-2">
                    <div class="col-12 col-md-6">
                        <div class="form-group">
                            <input ref="anotherEmail" type="email" class="form-control" v-model="form.anotherEmail"
                                name="anotherEmail" id="anotherEmail" :placeholder="translate.formUser.anotherEmail" />

                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group">
                            <select ref="country" class="select-box form-control" v-model="form.country" name="country"
                                id="country">
                                <option :value="null" disabled>{{ translate.formUser.country }}</option>
                                <option v-for="(country, value) in countries" :value="value" :key="value">
                                    {{ country }}
                                </option>
                            </select>

                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-6">
                        <div class="form-group">
                            <div class="d-flex flex-nowrap">
                                <input ref="password" type="password" class="form-control" v-model="form.password"
                                    name="password" id="password" :placeholder="translate.formUser.password" />
                                <i @click="hidePassword('password')" class="icon-eye"></i>
                            </div>

                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group">
                            <div class="d-flex flex-nowrap">
                                <input ref="confirmPassword" type="password" class="form-control"
                                    v-model="form.passwordAgain" name="passwordAgain" id="passwordAgain"
                                    :placeholder="translate.formUser.passwordAgain" />
                                <i @click="hidePassword('confirmPassword')" class="icon-eye"></i>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </fieldset>
</template>
  
<script lang="ts">
import { defineComponent, ref } from 'vue'
import tradutor from 'tradutors/assine'
import { mapState } from 'pinia'
import { localeStore } from 'stores/locale'
import api from '../../api'

export default defineComponent({
    name: 'FormUser',
    computed: {
        ...mapState(localeStore, ['locale']),
        translate: function () {
            this.getPaises()
            if (this.locale === 'pt-br') {
                return tradutor.portugues
            } else {
                return tradutor.ingles
            }
        }
    },
    data() {
        return {
            form: {
                firstName: null,
                lastName: null,
                email: null,
                emailAgain: null,
                anotherEmail: null,
                country: null,
                password: null,
                passwordAgain: null
            },
            countries: [
                'Brasil',
                'Portugal',
                'EUA',
                'Mexico'
            ]
        }
    },
    methods: {
        hidePassword(name) {
            let input = this.$refs[name]
            input.type == 'text' ? input.type = 'password' : input.type = 'text'
        },
        async getPaises() {
            api.get('v1/subscribe/getPaises?locale=' + this.locale).then(({ data }) => {
                this.countries = data
            }).catch(error => console.log(error))
        }
    }
})
</script>
  
<style scoped lang="css">
.form-group input {
    padding: 15px 20px;
    border-radius: 30px;
    margin-bottom: 15px;
    background-color: #fff;
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 13px;
    letter-spacing: 0;
}

.form-control:focus {
    color: #000;
    background-color: #f8f8f8;
}

.form-group i {
    position: absolute;
    top: 20%;
    right: 0;
    margin-right: 15px;
    font-size: x-large;
    cursor: pointer;
}

.select-box {
    padding-left: 22px;
    font-size: small;
    cursor: pointer;
}


.input-group-text {
    padding: 0;
    padding-left: 5px;
    font-size: 2rem;
    background-color: #f8f8f8;
    border: 1px solid #ced4da;
    border-radius: 30px;
    border-left-style: hidden;
    height: 51px;
}

.select-box {
    background-repeat: no-repeat;
    background-position-x: 95%;
    background-position-y: 50%;
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z" fill="rgb(178,0,0)"/></svg>');
}

legend {
    height: 28px;
    color: #B20000;
    font-family: 'Roboto-Medium';
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 28px;
    margin-bottom: 30px;
}

/* regras mobile 769vp */
@media screen and (max-width: 769px) {
    .div-user {
        width: 100%;
        margin-left: 0px;
    }

    legend {
        font-size: 18px;
    }
}
</style>
  